import { z } from 'zod';
import { PROFILE_LEVELS, ACCESS_MODULES } from './access.js';
import { ASSIGNABLE_ROLES } from './team.js';

const Level = z.enum(PROFILE_LEVELS, { errorMap: () => ({ message: 'مستوى غير صالح.' }) });

export const AccessPermissionsSchema = z
  .object({
    ...Object.fromEntries(ACCESS_MODULES.map((m) => [m, Level.optional()])),
    /** الصلاحياتُ التفصيليّة — مفاتيحُ الأفعالِ المسموحة (نمط زوهو). */
    __actions: z.array(z.string().max(64)).max(500).optional(),
  })
  .strict();

export const CreateAccessProfileSchema = z.object({
  name: z.string().trim().min(2, 'الاسم مطلوب.').max(80),
  description: z.string().trim().max(300).nullable().optional(),
  baseRole: z.enum(ASSIGNABLE_ROLES as [string, ...string[]], {
    errorMap: () => ({ message: 'دور غير صالح.' }),
  }),
  permissions: AccessPermissionsSchema.default({}),
});
export type CreateAccessProfileInput = z.infer<typeof CreateAccessProfileSchema>;

export const UpdateAccessProfileSchema = CreateAccessProfileSchema.partial();
export type UpdateAccessProfileInput = z.infer<typeof UpdateAccessProfileSchema>;

export const ProfileIdSchema = z.string().regex(/^[a-z0-9]{20,32}$/i, 'معرّف غير صالح.');
